
// Constants for article editor
export const DEFAULT_ARTICLE_METADATA = {
  readingTime: 0,
  tags: [],
  paymentType: 'free',
  isPaywalled: false,
  commentsEnabled: true,
  socialSharingEnabled: true,
  language: 'en'
};

export const SEO_DESCRIPTION_MAX_LENGTH = 160;
